import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /imports is retired — the Library (libraryBuild.md D-LIB.6) is the
 * home for bringing media in. Old links land there.
 */
export const Route = createFileRoute("/imports")({
  beforeLoad: () => {
    throw redirect({ to: "/library" });
  },
});
